export const ownerConstants = {
	SEND_OWNER_REQUEST: "SEND_OWNER_REQUEST",
	SEND_OWNER_SUCCESS: "SEND_OWNER_SUCCESS",
	SEND_OWNER_ERROR: "SEND_OWNER_ERROR",
};
